'use client';

import React from 'react';
import IndustriesContent from './IndustriesContent';

/**
 * Industries Page Component
 * 
 * This component renders the complete industries page using the original design
 * while following proper component organization principles.
 */
export default function IndustriesPage() {
  return <IndustriesContent />;
} 